import React, { ReactElement } from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppActionCard } from "./Generic/AppActionCard";

interface Props {
  onClick: () => void;
}

export function VideoRequestAssistance(props: Props): ReactElement {
  return (
    <AppActionCard
      className="VideoRequestAssistance"
      color="blue"
      text={translate(STRINGS.CHAT_WITH_SUPPORT)}
      action={translate(STRINGS.CHAT)}
      onClick={() => props.onClick()}
    />
  );
}
